var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconControlNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.491 0c.298 0 .595.085.883.252l17.257 10.017c.14.08.261.173.369.276V1.007a1 1 0 112 0v22a1 1 0 11-2 0V12.76a2.068 2.068 0 01-.332.26L3.386 23.724a1.736 1.736 0 01-.917.278c-.731 0-1.47-.561-1.47-1.632V1.646C1 .692 1.627 0 2.492 0zm.451 2.347v19.262L19 11.667 2.942 2.347z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconControlNext;